import React from "react";
import DecoratorImage from "../../../assets/images/decoratorTrust.png";

const WorkbookCover = ({ section }) => {
  const iconReturnHandler = (icon) => {
    switch (icon) {
      case "fist":
        return (
          <svg
            className="icon-fist w-14 h-14 mt-8"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 49 45"
          >
            <path
              fill="currentColor"
              fillRule="evenodd"
              d="M44.858 15.661a4.377 4.377 0 00-1.217-3.903 4.389 4.389 0 00-2.92-1.281c.085-.343.129-.697.129-1.059 0-1.177-.46-2.283-1.296-3.115a4.43 4.43 0 00-3.619-1.26 4.627 4.627 0 00-1.347-3.684 4.69 4.69 0 00-6.604 0l-4.538 4.518a6.637 6.637 0 00-3.235-.835 6.624 6.624 0 00-4.704 1.94l-4.154 4.135a6.566 6.566 0 00-1.78 6.166l.577 2.496-9.847 9.646a1.028 1.028 0 000 1.459 1.035 1.035 0 001.465 0l10.252-10.05c.253-.252.357-.614.277-.96l-.704-3.053a4.52 4.52 0 011.225-4.245l4.154-4.136a4.56 4.56 0 013.24-1.335A4.56 4.56 0 0123.45 8.44l3.521 3.506c.491.488.761 1.138.761 1.828 0 .691-.27 1.34-.76 1.829a2.586 2.586 0 01-1.837.757 2.586 2.586 0 01-1.837-.757l-2.05-2.041a1.04 1.04 0 00-1.465 0 1.028 1.028 0 000 1.458 7.12 7.12 0 010 10.09c-.476.474-.476 1.127-.072 1.53a1.035 1.035 0 001.465 0c2.347-2.337 3.183-5.499 2.584-8.425a4.722 4.722 0 002.077.152 4.406 4.406 0 004.204 2.172 4.353 4.353 0 001.275 3.489 4.407 4.407 0 003.42 1.273 4.164 4.164 0 001.219 3.345 4.201 4.201 0 001.937 1.098l-2.812 2.799a7.961 7.961 0 01-7.126 2.174l-2.868-.551a1.039 1.039 0 00-.929.283l-5.715 5.69a1.028 1.028 0 000 1.457 1.035 1.035 0 001.465 0l5.326-5.302 2.328.448c3.27.629 6.628-.396 8.984-2.74l11.22-11.171a4.193 4.193 0 000-5.943 4.215 4.215 0 00-2.907-1.227zM25.09 7.157l4.358-4.34a2.609 2.609 0 013.674 0c.49.49.76 1.138.76 1.83 0 .69-.27 1.34-.76 1.828l-4.375 4.355a4.714 4.714 0 00-.312-.343l-3.345-3.33zm2.712 10.43a2.342 2.342 0 001.86.906c.628 0 1.219-.243 1.663-.686l6.763-6.732c.445-.443.69-1.031.69-1.657 0-.626-.245-1.214-.69-1.657a2.364 2.364 0 00-3.329 0L29.7 12.8c.068.317.104.643.104.975a4.607 4.607 0 01-1.368 3.287c-.198.198-.41.372-.633.527zm4.293 3.336c0-.622.243-1.207.685-1.647l6.087-6.06a2.33 2.33 0 011.654-.682 2.33 2.33 0 011.654 3.976l-6.086 6.06a2.35 2.35 0 01-3.309 0 2.309 2.309 0 01-.685-1.647zm8.363 6.265l5.842-5.816a2.135 2.135 0 000-3.026 2.147 2.147 0 00-1.52-.625c-.55 0-1.1.208-1.52.625l-5.841 5.816a2.12 2.12 0 00-.63 1.513c0 .571.224 1.109.63 1.513a2.158 2.158 0 003.039 0z"
              clipRule="evenodd"
            ></path>
            <path
              fill="currentColor"
              d="M16.688 42.609c-.28 0-.555.114-.753.312a1.074 1.074 0 00-.312.753c0 .28.114.555.312.753.198.198.473.312.753.312s.555-.114.754-.312c.198-.198.312-.473.312-.753s-.114-.555-.313-.753a1.073 1.073 0 00-.753-.312z"
            ></path>
          </svg>
        );
      case "brain":
        return (
          <svg
            className="icon-brain w-14 h-14 mt-3 lg:mt-8 "
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 49 55"
          >
            <path
              fill="currentColor"
              d="M36.928 8.841a1.066 1.066 0 100 2.131 1.066 1.066 0 000-2.13zM26.275 8.841a1.066 1.066 0 10.001 2.132 1.066 1.066 0 000-2.132z"
            />
            <path
              fill="currentColor"
              fillRule="evenodd"
              d="M47.628 31.837C48.543 30.465 49 28.753 49 27.27a7.399 7.399 0 00-2.698-5.724 7.2 7.2 0 00.568-2.798c0-2.967-1.732-5.731-4.307-7.022.391-3.24-1.72-6.21-4.848-6.967C36.49 1.93 33.765 0 30.89 0c-2.674 0-5.073 1.56-6.391 3.836C23.182 1.56 20.783 0 18.109 0c-2.874 0-5.6 1.928-6.824 4.76-3.147.761-5.238 3.746-4.848 6.966-2.575 1.29-4.307 4.055-4.307 7.022a7.2 7.2 0 00.568 2.798A7.399 7.399 0 000 27.27c0 1.49.461 3.2 1.372 4.567A7.39 7.39 0 000 36.111c0 1.983.804 3.872 2.226 5.275-.731 4.42 2.794 8.892 7.361 8.892l.097-.001c1.514 2.612 4.325 4.262 7.36 4.262 3.162 0 5.988-1.898 7.456-4.633 1.468 2.735 4.294 4.633 7.456 4.633 3.035 0 5.845-1.65 7.36-4.262l.097.001c4.042 0 7.457-3.56 7.457-7.776 0-.359-.032-.728-.096-1.116A7.401 7.401 0 0049 36.11a7.39 7.39 0 00-1.372-4.274zM23.435 16.125a4.233 4.233 0 00-2.13-.573 1.065 1.065 0 100 2.13c1.174 0 2.13.956 2.13 2.131V40.07a8.502 8.502 0 00-6.391-2.894 1.065 1.065 0 100 2.13 6.399 6.399 0 016.39 6.392c0 3.637-2.926 6.71-6.39 6.71-2.467 0-4.737-1.458-5.785-3.715a1.066 1.066 0 00-1.086-.61l-.225.03c-3.032.414-6.446-3.02-5.522-6.86a1.065 1.065 0 00-.354-1.067C2.838 39.159 2.13 37.674 2.13 36.11c0-.966.274-1.912.782-2.741 1.278 1.047 2.867 1.676 4.545 1.676a1.065 1.065 0 100-2.13c-2.891 0-5.327-2.64-5.327-5.646 0-1.825.93-3.503 2.488-4.49.48-.303.637-.93.356-1.425-.473-.835-.713-1.712-.713-2.607 0-2.875 2.344-5.646 5.326-5.646 2.837 0 5.326 2.638 5.326 5.646a1.065 1.065 0 002.13 0c0-4.215-3.414-7.776-7.456-7.776a6.9 6.9 0 00-1.063.083v-.035c-.002-.016-.002-.032-.002-.048a4.26 4.26 0 014.26-4.261c1.139 0 2.209.443 3.014 1.248a1.065 1.065 0 001.506-1.507 6.348 6.348 0 00-3.533-1.795c.94-1.395 2.502-2.527 4.34-2.527 2.837 0 5.326 2.639 5.326 5.646v8.35zM46.088 33.37c-1.278 1.047-2.867 1.676-4.544 1.676a1.065 1.065 0 010-2.13c2.882 0 5.326-2.629 5.326-5.646 0-1.825-.93-3.503-2.488-4.49a1.065 1.065 0 01-.356-1.425c.473-.835.713-1.712.713-2.607 0-2.877-2.345-5.646-5.326-5.646-2.837 0-5.326 2.638-5.326 5.646a1.065 1.065 0 01-2.13 0c0-4.215 3.414-7.776 7.456-7.776a6.9 6.9 0 011.063.083v-.035c.002-.016.002-.032.002-.048a4.26 4.26 0 00-4.26-4.261 4.238 4.238 0 00-3.015 1.248 1.065 1.065 0 11-1.505-1.508c.972-.97 2.2-1.59 3.533-1.795-.94-1.394-2.502-2.526-4.34-2.526-2.837 0-5.326 2.639-5.326 5.646v8.35a4.233 4.233 0 012.13-.574 1.065 1.065 0 010 2.13c-1.174 0-2.13.956-2.13 2.131V40.07a8.502 8.502 0 016.391-2.894 1.065 1.065 0 010 2.13 6.399 6.399 0 00-6.39 6.392c0 3.637 2.926 6.71 6.39 6.71 2.467 0 4.737-1.458 5.785-3.715.193-.416.63-.661 1.086-.61l.225.03c2.697.368 5.687-2.304 5.687-5.61 0-.384-.052-.78-.165-1.25a1.065 1.065 0 01.354-1.067c1.234-1.027 1.942-2.512 1.942-4.075 0-.966-.274-1.912-.782-2.74z"
              clipRule="evenodd"
            />
            <path
              fill="currentColor"
              d="M28.134 22.801a1.065 1.065 0 00-1.504-.083c-3.415 3.055-8.876.613-8.876-3.97a1.065 1.065 0 10-2.13 0c0 3.698 2.706 6.774 6.241 7.356a3.201 3.201 0 01-3.046 2.23 1.065 1.065 0 100 2.131 5.334 5.334 0 005.23-4.325 7.444 7.444 0 004.002-1.835 1.065 1.065 0 00.084-1.504zM16.688 41.437a1.065 1.065 0 100 2.13c2.838 0 5.327 2.639 5.327 5.646a1.065 1.065 0 102.13 0c0-4.215-3.415-7.776-7.457-7.776zM25.21 32.915a9.567 9.567 0 00-8.34 4.858 1.065 1.065 0 001.853 1.051 7.44 7.44 0 016.487-3.778 1.065 1.065 0 100-2.13zM44.384 28.335a3.202 3.202 0 01-3.047-2.231c3.536-.582 6.243-3.658 6.243-7.356a1.065 1.065 0 00-2.13 0 5.332 5.332 0 01-5.327 5.326 5.32 5.32 0 01-3.55-1.356 1.065 1.065 0 10-1.42 1.587 7.444 7.444 0 004 1.835 5.334 5.334 0 005.231 4.325 1.065 1.065 0 000-2.13zM46.514 41.437c-4.041 0-7.456 3.561-7.456 7.776a1.065 1.065 0 102.13 0c0-3.007 2.49-5.646 5.326-5.646a1.065 1.065 0 000-2.13zM46.333 37.774a9.566 9.566 0 00-8.34-4.859 1.065 1.065 0 000 2.13 7.44 7.44 0 016.487 3.78 1.065 1.065 0 001.853-1.051z"
            />
          </svg>
        );
      case "arrow":
        return (
          <svg
            className="icon-arrow w-20 h-20 mt-8"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 74 74"
          >
            <path
              fill="currentColor"
              d="M42.3 23.682L14.665 51.317a5.288 5.288 0 000 7.47 5.288 5.288 0 007.47 0L49.768 31.15v9.109c0 1.41.55 2.735 1.549 3.734a5.245 5.245 0 003.733 1.548c1.411 0 2.738-.55 3.735-1.547a5.248 5.248 0 001.547-3.735V18.4c0-1.41-.549-2.737-1.547-3.735a5.247 5.247 0 00-3.735-1.547H33.19c-1.41 0-2.737.55-3.735 1.547A5.248 5.248 0 0027.91 18.4a5.288 5.288 0 005.282 5.282H42.3zm7.834 3.59L20.377 57.027a2.799 2.799 0 01-3.954 0 2.799 2.799 0 010-3.954l29.756-29.756a1.243 1.243 0 00-.878-2.122H33.19a2.8 2.8 0 01-2.796-2.796c0-.747.29-1.45.819-1.977a2.777 2.777 0 011.977-.819h21.86c.747 0 1.45.29 1.977.819.528.528.82 1.23.82 1.977v21.86c0 .747-.292 1.449-.82 1.977a2.777 2.777 0 01-1.977.819 2.777 2.777 0 01-1.976-.82 2.777 2.777 0 01-.82-1.976V28.15a1.243 1.243 0 00-2.121-.879z"
            ></path>
            <path
              fill="currentColor"
              d="M54.164 31.496v-.349a1.243 1.243 0 012.486 0v.349a1.24 1.24 0 01-1.243 1.243 1.243 1.243 0 01-1.243-1.243zM54.163 27.744v-9.182a1.243 1.243 0 012.487 0v9.182a1.24 1.24 0 01-1.243 1.243 1.243 1.243 0 01-1.243-1.243z"
            ></path>
          </svg>
        );
      default:
        return;
    }
  };
  return (
    <>
      <div className="relative">
        <div className="container mx-auto lg:px-17 px-0">
          <div>
            <h1 className="text-5xl lg:text-116 font-black leading-48 lg:leading-110 text-center font-Dazzed px-4 lg:px-44 pb-40">
              {section?.mainHeading}
            </h1>

            {section?.features?.map((feature, index) => {
              if (index % 2 === 0) {
                return (
                  <div
                    key={index}
                    className={`container mx-auto ${
                      index === 0
                        ? "pb-0"
                        : index === section?.features?.length - 1
                        ? "pb-20"
                        : "pb-20 lg:pb-80 "
                    }`}
                  >
                    <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center px-5 xl:px-0">
                      <div className="border rounded-full border-black w-44 h-44 lg:h-64 lg:w-64 flex items-start justify-center text-primary-red relative">
                        {iconReturnHandler(feature?.icon)}
                        <h1
                          className={`absolute left-0 text-5xl lg:text-7xl font-bold font-Dazzed text-primary-red ${
                            feature?.title?.length > 9
                              ? "ml-0 xl:ml-16 top-24"
                              : "ml-28 xl:ml-40 top-20"
                          }`}
                        >
                          {feature?.title || ""}
                        </h1>
                      </div>
                      <div className="w-full lg:w-2/4 pr-0 lg:pr-36 pt-5 lg:pt-0">
                        <h1 className="text-2xl font-bold">
                          {feature?.heading || ""}
                        </h1>
                        <p className="text-2xl pt-6">
                          {feature?.content || ""}
                        </p>
                        <p className="text-2xl pt-5">
                          {feature?.contentTwo || ""}
                        </p>
                      </div>
                    </div>
                    {index === 0 && (
                      <div className="w-full md:h-52">
                        <img
                          className="w-full mx-auto pt-2 md:absolute left-0 right-0"
                          src={DecoratorImage}
                          alt="decorator"
                          loading="lazy"
                        />
                      </div>
                    )}
                  </div>
                );
              } else
                return (
                  <div
                    key={index}
                    className={`container mx-auto ${
                      index === section?.features?.length - 1
                        ? "pb-20"
                        : "pb-20 lg:pb-80"
                    }`}
                  >
                    <div className="flex flex-col-reverse lg:flex-row justify-between items-end lg:items-center px-5 xl:px-0">
                      <div className="w-full lg:w-3/5 pr-0 lg:pr-24 pt-5 lg:pt-0">
                        <h1 className="text-2xl font-bold mt-8 lg:mt-0">
                          {feature?.heading || ""}
                        </h1>
                        <p className="text-2xl pt-6 lg:pr-0">
                          {feature?.content || ""}
                        </p>
                        <p className="text-2xl pt-6 lg:pr-0">
                          {feature?.contentTwo || ""}
                        </p>
                      </div>
                      <div className="w-full lg:w-2/4 flex justify-end lg:justify-center mr-0 lg:mr-28">
                        <div className="text-primary-red border rounded-full border-black w-44 h-44 lg:h-64 lg:w-64 flex items-start justify-center relative">
                          {iconReturnHandler(feature?.icon)}
                          <h1
                            className={`absolute    left-0 text-5xl lg:text-7xl font-bold font-Dazzed text-primary-red -ml-28 ${
                              feature?.title?.length > 9
                                ? "xl:ml-24 top-24"
                                : "xl:ml-40 top-20"
                            }`}
                          >
                            {feature?.title || ""}
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
export default WorkbookCover;
